import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
	useTheme,
} from "@mui/material";
import moment from "moment";
import { TableLoader, TableNotFound } from "src/Utils/TableLoader";
import type { TCollectionReport } from "./type/reportType";
type IProps = {
	isLoading: Boolean;
	data: TCollectionReport[];
};
const CollectionReportTable = ({ isLoading, data }: IProps) => {
	const theme = useTheme();
	return (
		<>
			<TableContainer>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>SL.</TableCell>
							<TableCell>Voucher No.</TableCell>
							<TableCell>Date</TableCell>
							<TableCell>Collected from</TableCell>
							<TableCell>Client Type</TableCell>
							<TableCell>Created by</TableCell>
						</TableRow>
					</TableHead>

					{isLoading ? (
						<TableLoader />
					) : data.length ? (
						<TableBody>
							{data?.map((allAdmin, index) => {
								return (
									<TableRow hover key={allAdmin.id}>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{index + 1}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{allAdmin.money_receipt_no}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{moment(
													allAdmin.payment_date
												).format("DD-MMM-YYYY")}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												gutterBottom
												noWrap
											>
												{allAdmin.client_name}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
												// gutterBottom
												// noWrap
											>
												{allAdmin.source === "B2B"
													? allAdmin.source
													: allAdmin.source ===
													  "Visitor"
													? allAdmin.source
													: allAdmin.source}
											</Typography>
										</TableCell>
										<TableCell>
											<Typography
												variant='body1'
												color='text.primary'
											>
												{allAdmin.created_by}
											</Typography>
										</TableCell>
									</TableRow>
								);
							})}
						</TableBody>
					) : (
						<TableNotFound />
					)}
				</Table>
			</TableContainer>
		</>
	);
};

export default CollectionReportTable;
